<template>
  <div class="page-personal-home">
    <ml-header class="header" />
    <div class="album">
      <img :src="goddess.avatar" alt="" />
      <div class="personal-info">
        <div class="row">
          <p>
            <span>{{ goddess.nickname }}</span
            ><img :src="female" alt="" />
          </p>
          <button @click="handleAttentionUser(goddess.followed)">
            {{ goddess.followed | attentionFilter }}
          </button>
        </div>
        <div class="row">
          <span>ID:{{ goddess.id }}</span
          ><span>·</span><span>{{ goddess.fanNum }}粉丝</span>
        </div>
      </div>
    </div>
    <div class="content">
      <Tabs
        class="tabs"
        :tab-list="['资料', '相册', '视频']"
        :active.sync="activeIndex"
      />
      <info-tab-view :goddess="goddess" v-if="activeIndex === INFO_VIEW" />
      <photo-tab-view :photos="photos" v-if="activeIndex === PHOTO_VIEW" />
      <video-tab-view :videos="videos" v-if="activeIndex === VIDEO_VIEW" />
    </div>
    <div class="footer">
      <ml-button @click="call">发消息</ml-button>
      <ml-button :is-theme-color="true" @click="call">撩Ta</ml-button>
    </div>
    <ml-popup :open.sync="openPopup" :show-icon="!isMasonryVip">
      <div class="popup">
        <h1>温馨提示</h1>
        <template v-if="isMasonryVip">
          <p>
            为共同维护平台正常运营 请私联女神QQ：<span style="color:#FF7500">{{
              qq
            }}</span>
          </p>
          <ml-button :is-theme-color="true" width="220px" @click="navigateTo"
            >知道了</ml-button
          >
        </template>
        <template v-else>
          <p>此项目仅限钻石VIP会员开放</p>
          <ml-button :is-theme-color="true" width="220px" @click="navigateTo"
            >开通VIP会员</ml-button
          >
        </template>
      </div>
    </ml-popup>
  </div>
</template>

<script>
import Tabs from "@/components/Tabs";
import female from "@/assets/personal/female@2x.png";
import {
  getPersonalHomeInfo,
  getPersonalHomePhotos,
  getPersonalHomeVideos,
  getGoddessQQ
} from "@/api/goddness";
import { attentionUser, cancelAttentionUser } from "@/api/user";
import InfoTabView from "@/views/personal/components/InfoTabView";
import PhotoTabView from "@/views/personal/components/PhotoTabView";
import VideoTabView from "@/views/personal/components/VideoTabView";
import { mapGetters } from "vuex";

const INFO_VIEW = 0;
const PHOTO_VIEW = 1;
const VIDEO_VIEW = 2;

export default {
  name: "PersonalHome",
  components: {
    InfoTabView,
    PhotoTabView,
    VideoTabView,
    Tabs
  },
  filters: {
    attentionFilter(isFollow) {
      return isFollow ? "已关注" : "关注";
    }
  },
  watch: {
    activeIndex(newVal, oldVal) {
      if (newVal === oldVal) return;
      switch (newVal) {
        case INFO_VIEW:
          this.fetchGoddessData();
          break;
        case PHOTO_VIEW:
          this.fetchPhotosData();
          break;
        case VIDEO_VIEW:
          this.fetchVideosData();
          break;
      }
    }
  },
  computed: {
    ...mapGetters("user", ["isMasonryVip"])
  },
  data() {
    return {
      female,
      activeIndex: 0,
      openPopup: false,
      goddessId: this.$route.params.id,
      goddess: {
        goddessInfoRes: {}
      },
      videos: [],
      photos: [],
      qq: "123213",
      // 常量
      INFO_VIEW,
      PHOTO_VIEW,
      VIDEO_VIEW
    };
  },
  created() {
    this.fetchGoddessData();
  },
  methods: {
    async fetchGoddessData() {
      this.goddess = await getPersonalHomeInfo(this.goddessId);
    },
    async fetchVideosData() {
      const responseData = await getPersonalHomeVideos(this.goddessId);
      this.videos = responseData.content;
    },
    async fetchPhotosData() {
      const responseData = await getPersonalHomePhotos(this.goddessId);
      this.photos = responseData.content;
    },
    async call() {
      if (this.isMasonryVip) {
        this.qq = await getGoddessQQ(this.goddessId);
      }
      this.openPopup = true;
    },
    navigateTo() {
      this.$router.push({ name: "vip" });
    },
    async handleAttentionUser(followed) {
      if (followed) {
        await cancelAttentionUser(this.goddessId);
        this.goddess.followed = false;
      } else {
        await attentionUser(this.goddessId);
        this.goddess.followed = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-personal-home {
  .album {
    position: relative;
    padding-top: 280px;
    width: 100%;
    background-size: 100% 100%;
    > img {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      z-index: -1;
    }
  }
  .content {
    margin-top: -15px;
    padding: 17px 15px 70px 15px;
    width: 100%;
    min-height: 80vh;
    background: rgba(255, 255, 255, 1);
    border-radius: 12px 12px 0 0;
    display: flex;
    flex-direction: column;
    .tabs {
      margin-bottom: 16px;
    }
  }
  .personal-info {
    padding: 0 15px;
    .row:nth-child(1) {
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 22px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
      }
      img {
        margin-left: 9px;
        width: 15px;
        height: 18px;
      }
      button {
        border: none;
        outline: none;
        width: 58px;
        height: 25px;
        background: rgba(253, 215, 0, 1);
        border-radius: 28px;
        font-size: 14px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 25px;
      }
    }
    .row:nth-child(2) {
      margin-top: 15px;
      display: flex;
      justify-content: flex-start;
      span {
        font-size: 13px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 18px;
      }
      span:nth-child(2) {
        margin: 0 5px;
      }
    }
  }
  .footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 70px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  }
  .popup {
    display: flex;
    flex-direction: column;
    align-items: center;
    h1 {
      font-size: 16px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;
    }
    p {
      margin: 15px 0 30px 0;
    }
  }
}
</style>
